import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const AboutUs = () => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("about");
      setDates(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!dates) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <div className="container my-5 p-4 border rounded bg-light shadow-sm">
        <div
          className="section-title text-center position-relative pb-3 mb-2 mx-auto"
          style={{ maxWidth: "600px" }}
        >
          <h5 className="fw-bold text-primary text-uppercase">
            About the Conference
          </h5>
          <h2 className="mb-0 w-full">{dates?.title[0]?.text}</h2>
        </div>
        <hr />
        {/* <p className="text-justify">
          <b>
            B. M. Institute of Engineering and Technology, Sonipat, India in
            association with Novel Research Foundation is organizing Third
            International Conference on Advanced Computing & Communication
            Technologies (Third ICACCTech 2025) on 20-21 September 2025 at B. M.
            Institute of Engineering and Technology, Sonipat, India.
          </b>
          <br />
          <br />
          Third International Conference on Advanced Computing & Communication
          Technologies (ICACCTech 2025) promises to address current state of the
          technology and the outcome of the ongoing research in the area of
          advance computing and communication. Computer and communication has
          immensely enhanced the level of information acquisition, retrieval and
          processing. ICACCTech 2025 would offer a forum to the academicians,
          researchers and students to interact with experts in the area and to
          learn the recent knowledge in advance computing. We invite original &
          unpublished work from individuals active in the broad theme of the
          conference.
          <br />
          <b>
            Venue: B. M. Institute of Engineering and Technology, Sonipat, India
          </b>
          <br />
          <b>
            Conference proceedings will be published with ISBN number in
            electronic form by CPS and shall be submitted to Xplore and CSDL by
            CPS.
          </b>
        </p> */}
        {dates.description.map((para, index) => (
          <p
            key={index}
            className="about-description mb-4"
            style={{ fontSize: dates.description[0]?.fontSize }}
          >
            {para.text}
          </p>
        ))}
      </div>
      {/* <div className="container my-5">
        <div className="p-4 rounded bg-dark text-white shadow-sm">
          <h3 className="fw-bold">Conference Record Number - 65084</h3>
          <h3 className="fw-bold">
            <a href="https://www.ieee.org/conferences/organizers/conf-app.html?confRecNum=65084">
              Conference Record Number - 65084
            </a>
          </h3>
          <p>
            <b>
              All accepted papers will be submitted by CPS to the indexing
              companies for possible indexing (Scopus, Ei Compendex and other
              major Indexes).
            </b>
            <br />
            <br />
            1st International Conference on Advanced Computing & Communication
            Technologies was held at Swami Vivekanand Institute of Engineering
            and Technology was held at 23-24 December 2023.
            <br />
            <b>All papers of 1st ICACCTech 2023 were published in xplore.</b>
            <br />
            Link of 1st ICACCTech 2023 published papers:{" "}
            <a href="https://ieeexplore.ieee.org/xpl/conhome/10440965/proceeding">
              Xplore - Conference Table of Contents
            </a>
            <br />
            <br />
            2nd International Conference on Advanced Computing & Communication
            Technologies was held at Ethnic India, Rai, Sonipat, Delhi - NCR,
            India was held on 16th & 17th November 2024.
            <br />
            <b>All papers of 1st ICACCTech 2025 were published in xplore.</b>
            <br />
            Link of 1st ICACCTech 2023 published papers:{" "}
            <a href="https://ieeexplore.ieee.org/xpl/conhome/10440965/proceeding">
              Xplore - Conference Table of Contents
            </a>
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default AboutUs;
